import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useHistory } from 'react-router-dom'

import { AbsenceRequestForm } from '..'
import { Spinner } from '../../../../App/Components'
import {
  Dashboard,
  DashBoardHeading,
  DashBoardItem,
  OutOfDashBoard,
} from '../../../../App/Components/Container/DashBoard/Dashboard'
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../App/Hooks/reduxHooks'
import { IAbsenceRequest } from '../../../../HR/AbsenceRequests/Client/IAbsenceRequest'
import { updateAbsenceRequest } from '../../../../HR/AbsenceRequests/Store/Actions'
import {
  BottomNavigationSetup,
  ProfileDashboardHeading,
} from '../../../Components'
import { headingStyle } from '../../Profile/style'

export const UpdateAbsenceRequest = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { absenceRequestId } = useParams<{ absenceRequestId: string }>()
  const history = useHistory()

  const currentUser = useAppSelector(state => state.users.currentUser)
  const absenceRequest = useAppSelector(state =>
    state.hr.absenceRequests.list.find(
      oneAbsenceRequest => oneAbsenceRequest.id === absenceRequestId,
    ),
  )
  const establishment = useAppSelector(state => state.establishment.active)

  if (!establishment.permissions.includes('absence_requests')) {
    return (
      <p>
        {t("You don't have the required subscription type to view this page")}
      </p>
    )
  }

  const submitFunction = (updatedRequest: IAbsenceRequest) => {
    dispatch(updateAbsenceRequest(updatedRequest)).then(() =>
      history.push(`/profile`),
    )
  }

  if (!absenceRequest || !currentUser) {
    return <Spinner />
  }

  return (
    <Dashboard itemColumnCount={1} headingStyle={headingStyle}>
      <DashBoardHeading>
        <ProfileDashboardHeading />
      </DashBoardHeading>
      <DashBoardItem>
        <h1>{t('Edit absence')}</h1>
        <AbsenceRequestForm
          absenceRequest={absenceRequest}
          actionType={'edit'}
          onSubmit={(request: IAbsenceRequest) => submitFunction(request)}
          isDisabled={absenceRequest.status !== 'PENDING'}
        />
      </DashBoardItem>
      <OutOfDashBoard key={'profileOutOfDashboard'}>
        <BottomNavigationSetup currentUser={currentUser} />
      </OutOfDashBoard>
    </Dashboard>
  )
}
